<template>
  <div class="Login">
    <div class="form">
      <md-card-media>
        <img
          src="@/assets/img/portada.svg"
          alt=""
        >
      </md-card-media>
      <md-card-content>
        <md-field>
          <label>Usuario</label>
          <md-input
            v-model="usuario"
            @keyup.native.enter="_doLogin"
          />
        </md-field>
        <md-field>
          <label>Contraseña</label>
          <md-input
            v-model="password"
            @keyup.native.enter="_doLogin"
            type="password"
          />
        </md-field>
      </md-card-content>
      <md-card-actions>
        <md-button
          class="md-raised md-primary"
          @click="_doLogin()"
        >Iniciar sesión</md-button>
      </md-card-actions>
    </div>
  </div>
</template>

<script>
import md5 from "blueimp-md5";
import sha1 from "js-sha1";

export default {
  name: "Login",
  data() {
    return {
      usuario: null,
      password: null
    };
  },
  methods: {
    _doLogin() {
      this.$headers.headers.Token = null;
      this.$http
        .post("login", {
          a: this.usuario,
          b: sha1(md5(this.password))
        })
        .then(
          res => {
            if (res.status === 200 && "token" in res.body) {
              this.$session.start();
              this.$headers.headers.Token = res.body.token;
              this.$session.set("nombre", res.body.nombre);
              this.$session.set("token", res.body.token);
              this.$session.set("tipo", res.body.tipo);
              this.$emit("msg", "HOLA " + res.body.nombre);
              this.$router.push("/");
            } else {
              this.$emit("msg", "Usuario o contraseña incorrecta");
            }
          },
          err => {
            this.$emit("msg", this.$no_internet);
          }
        );
    }
  },
  beforeCreate() {
    this.$session.destroy();
  },
  created() {
    this.$headers.headers.Token = "";
    this.$emit("visible", false);
    this.$emit("classes", "");
    localStorage.setItem("categorias_escuelas", JSON.stringify([]));
    localStorage.setItem("escuelas", JSON.stringify([]));
    localStorage.setItem("escuelas_contactos", JSON.stringify([]));
    localStorage.setItem("escuelas_citas", JSON.stringify([]));
    localStorage.setItem("pacientes", JSON.stringify([]));
  }
};
</script>
<style scoped>
.form {
  max-width: 350px;
  width: 100%;
  align-self: center;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 50px;
}
</style>